import { api } from '../api';

/**
 * As chamadas da classificação SUCS e HRB (onda 217), com os caminhos
 * escritos por extenso — o teste `26` precisa enxergar a string literal.
 */

export interface CandidataGranulometria {
  id: string;
  metodo_codigo: string;
  metodo_nome: string;
  data_execucao: string | null;
  laudo: string | null;
  com_sedimentacao: boolean;
  passa_200: number | string | null;
  origem_200: string | null;
}

export interface CandidataLimite {
  id: string;
  metodo_codigo: string;
  metodo_nome: string;
  data_execucao: string | null;
  laudo: string | null;
  limite_liquidez?: number | string | null;
  nao_liquido?: boolean;
  limite_plasticidade?: number | string | null;
  nao_plastico?: boolean;
  situacao: string;
}

export interface EnsaioClassificacao {
  ensaio: { id: string; status: string; metodo_codigo: string };
  /** `null` enquanto as fontes não foram escolhidas. */
  classificacao: any | null;
  candidatas: {
    granulometrias: CandidataGranulometria[];
    liquidez: CandidataLimite[];
    plasticidade: CandidataLimite[];
  };
  pendenciasDetalhadas?: any[];
  pendencias: string[];
}

export const verClassificacao = (id: string) =>
  api<EnsaioClassificacao>(`/ensaios/${id}/classificacao`);

export const gravarClassificacao = (id: string, corpo: unknown) =>
  api<EnsaioClassificacao>(`/ensaios/${id}/classificacao`,
    { metodo: 'PUT', corpo });
